<template>
  <v-dialog v-model="statusDialog" scrollable persistent max-width="300px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="lead-bottom-control-panel__btn"
        color="primary darken-1"
        v-bind="attrs"
        v-on="on"
        @click="openStatusDialog"
      >
        <v-icon color="white">mdi-sync</v-icon>
        <span class="lead-bottom-control-panel__item-text white--text"
          >status</span
        >
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Select Status</v-card-title>
      <v-divider />
      <v-card-text style="height: 300px">
        <v-radio-group v-model="lead.status" column>
          <b class="my-2">Pre-Contact</b>
          <v-divider class="mb-2" />
          <v-radio label="New Lead" value="newLead" />
          <v-radio label="Contact attempt 1" value="contactAttempt1" />
          <v-radio label="Contact attempt 2" value="contactAttempt2" />
          <v-radio label="Contact attempt 3" value="contactAttempt3" />
          <v-radio label="Contact attempt 4" value="contactAttempt4" />
          <v-radio label="Wrong Phone number" value="wrongPhoneNumber" />
          <b class="my-2">Pre-Quote</b>
          <v-divider class="mb-2" />
          <v-radio label="Do not call" value="doNotCall" />
          <v-radio label="Did not want quote" value="notInterested" />
          <v-radio label="Call Back" value="followUp" />
          <b class="my-2">After Quote</b>
          <v-divider class="mb-2" />
          <v-radio label="Price Too High" value="priceTooHigh" />
          <v-radio label="Emailed Quote" value="emailed" />
          <v-radio label="Thinking about it" value="thinkingAboutIt" />
          <v-radio label="Agreement" value="agreement" />
          <v-radio label="In App" value="inApplication" />
          <b class="my-2">After Submitted</b>
          <v-divider class="mb-2" />
          <v-radio label="Underwriting" value="underwriting" />
          <v-radio label="Approved" value="approved" />
          <v-radio label="AOTA" value="aota" />
          <v-radio label="Cond Issued" value="condIssued" />
          <!-- <v-radio label="Purchased" value="purchased" /> -->
          <v-radio label="In-force" value="in-force" />
          <v-radio label="Declined" value="declined" />
          <v-radio label="Cancelled" value="cancelled" />
        </v-radio-group>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <!-- <v-btn color="blue darken-1" text @click="closeDialog"> Close </v-btn> -->
        <v-btn
          color="blue darken-1"
          :disabled="lead.status == 'newLead'"
          text
          @click="statusHandler"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "StatusDialog",
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    ...mapMutations({
      SET_UNCOMPLETED_LEAD: "auth/SET_UNCOMPLETED_LEAD",
      SET_NECESSARY_DIALOG: "followups/SET_NECESSARY_DIALOG",
      SET_FOLLOWUP: "followups/SET_FOLLOWUP",
      SET_STATUS_DIALOG: "statuses/SET_STATUS_DIALOG",
    }),
    openStatusDialog() {
      this.SET_STATUS_DIALOG(true);
    },
    statusHandler() {
      this.SET_STATUS_DIALOG(false);
      this.$socket.emit("update-status", this.lead.id, this.lead.status);
      if (
        this.lead.status == "contactAttempt1" ||
        this.lead.status == "contactAttempt2" ||
        this.lead.status == "contactAttempt3" ||
        this.lead.status == "contactAttempt4" ||
        this.lead.status == "followUp" ||
        this.lead.status == "thinkingAboutIt" ||
        this.lead.status == "emailed" ||
        this.lead.status == "inApplication" ||
        this.lead.status == "underwriting"
      ) {
        let priorityIndex,
          dateTime = null;

        if (this.followups[0]) {
          priorityIndex = this.priorities.findIndex(
            (item) => item.value === this.followups[0].priority
          );
          dateTime = new Date(this.followups[0].datetime);
        }

        this.SET_FOLLOWUP({
          id: this.followups[0] ? this.followups[0].id : null,
          datetime: this.followups[0] ? dateTime.toISOString() : null,
          description: this.followups[0] ? this.followups[0].description : null,
          priority: this.followups[0] ? this.priorities[priorityIndex].key : 3,
        });

        this.SET_NECESSARY_DIALOG(true);
      } else {
        this.$axios
          .patch(`/agents/${this.user.id}/completed_lead`)
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((err) => {
            this.showHandlerSnackbar({
              color: err.response.status,
              text: err.response.message,
              show: true,
            });
          });
        this.SET_UNCOMPLETED_LEAD(null);
      }
    },
    // closeDialog() {
    //   this.SET_STATUS_DIALOG(false);
    // },
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      user: "auth/user",
      priorities: "followups/priorities",
      necessaryDialog: "followups/necessaryDialog",
      statusDialog: "statuses/statusDialog",
      followups: "followups/followups",
    }),
  },
};
</script>